module.exports = __webpack_public_path__ + "assets/img/benefit-health.8fe4a13b.png";